
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class TypeProp extends Vue {
  @Prop() value!: number | string
  @Prop({default: false}) showTemp!: boolean
  @Prop({default: []}) typeList!: Array<any>

  confirm (value) {
    this.$emit('load', value)
  }

  cancel () {
    this.$emit('cancel')
  }
}
